import React from "react";
import {
  useNavigate,
} from "react-router-dom";
import { format, parseJSON } from "date-fns";
import humanize from "underscore.string/humanize";
import titleize from "underscore.string/titleize";
import { formatMoney } from "../../utils/currrency";
import { 
  ResponsiveTable,
  Paginator,
  ErrorBoundary,
  Loaders,
} from "..";
import { 
  useOffersList,
} from "../../queries/offer";
import usePagination from "../../hooks/usePagination";

function OffersList({companyId}) {
  const navigate = useNavigate();
  const pageConfig = usePagination();
  const offersList = useOffersList({...pageConfig.current, company_id: companyId})

  const openOfferView = React.useCallback(
    (row) => navigate(row.original.slug),
    [navigate]
  )

  const tableData = React.useMemo(
    () => {
      if (offersList.isSuccess)
        return offersList.data.data
      else
        return []
    },
    [offersList]
  );


  const columns = React.useMemo(
    () => {
      if (offersList.isSuccess){
        return [
          { 
            Header: 'Offer name',
            accessor: 'name',
            Cell: ({value}) => titleize(value),
          },
          { 
            Header: 'Created',
            accessor: 'created_at',
            Cell: ({value}) => format(parseJSON(value), 'MMM dd, yyyy'),
          },
          {
            Header: 'Goal',
            accessor: 'deal.maximum_goal',
            Cell: ({value}) => formatMoney(value, {precision: 0}),
          },
          {
            Header: 'Amt funded',
            accessor: 'deal.raised',
            Cell: ({value}) => formatMoney(value, {precision: 0}),
          },
          {
            Header: 'Status',
            accessor: 'status',
            Cell: ({value}) => humanize(value),
          }
        ]
      }
      else{
        return []
      }
    },
    [offersList]
  );

  if (offersList.isLoading)
    return <Loaders.TableLoader />

  return (
    <ErrorBoundary>
      {/* <Paginator
        theme='dark'
        onPage={pageConfig.setPage}
        meta={offersList.data.pagy}
      /> */}
      <ResponsiveTable title="Offers" columns={columns} data={tableData} onClickRow={openOfferView} />
    </ErrorBoundary>
  );
}

OffersList.defaultProps = {};

OffersList.propTypes = {};

export default OffersList;